// Safe JSON-LD serializer for injection into <script type="application/ld+json">.
//
// JSON.stringify escapes quotes but NOT the '<' character, so any field that
// contains "</script>" (or any "<...") would break out of the script element
// and execute as HTML - a stored-XSS sink when the serialized object includes
// any operator-, AI-, or user-supplied text (titles, meta descriptions,
// reviews, glossary/brand content). Escaping '<' to its < unicode form
// keeps the JSON byte-for-byte valid for parsers while making tag-breakout
// impossible.
//
// Use everywhere a JSON-LD object is rendered via v-html / domProps.innerHTML /
// dangerouslySetInnerHTML instead of bare JSON.stringify(). Named ldJson (not
// jsonLd) on purpose: the data objects in these components are themselves
// frequently named `jsonLd`, so a same-named helper would shadow them.
export const ldJson = (obj) => JSON.stringify(obj).replace(/</g, '\\u003c');
